import * as React from "react";
import type { SVGProps } from "react";
const SvgInformationInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 9c-.13 0-.26-.03-.38-.08q-.18-.075-.33-.21-.135-.15-.21-.33A.84.84 0 0 1 11 8c0-.06 0-.13.02-.19.01-.07.03-.13.06-.19q.03-.09.09-.18c.02-.033.049-.067.078-.1l.042-.05q.15-.135.33-.21c.36-.16.81-.07 1.09.21l.042.05q.046.05.078.1.06.09.09.18c.03.06.05.12.06.19.01.06.02.13.02.19 0 .13-.02.26-.08.38q-.075.18-.21.33c-.19.18-.45.29-.71.29M11 12h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v4h1c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1h1z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12m2 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInformationInCircle;
